import { mapState } from 'vuex';
import InlineError from '@C/Forms/InlineError';
import FlashMessage from '@C/FlashMessage';
import LoaderedButton from '@C/LoaderedButton';
import CountrySelect from '@C/CountrySelect';
import AutoCompleteInput from '@C/AutoCompleteInput';
import Input from '@C/Forms/Input';
import Checkbox from '@C/Checkbox';
import errorsMixin from '@M/errors';
import validator from '@M/validationWrapper';
import autocomplete from '@M/autocomplete';
import initScrollbar from '@H/addScrollbar';
import { isDesktop } from '@H/device_helpers';

export default {
    props: {
        activeSubscriptions: {
            type: [Array]
        }
    },
    mounted() {
        this.$nextTick(() => {
            initScrollbar();
        });
    },
    computed: {
        ...mapState('Widget', ['user', '_widgetInstance', 'subscriptions']),
        hasScroll() {
            return isDesktop() ? 'perfect-scrollbar' : 'overflowy-scroll';
        }
    },
    methods: {
        submitForm() {
            this.$refs.form.dispatchEvent(
                new Event('submit', { cancelable: true })
            );
        },
        closeSelf() {
            // Causes the dialog to close, and sends the parent an SC.Error object
            // containing a myResultData block. The caller receives this as the EV.result.myResultData in its dialog callback function
            this._widgetInstance.SendDialogResult(
                new SC.Error({ code: SC.errors.ErrorCodes.NOERROR })
            );
        },
        reloadUser() {
            this._widgetInstance.SaveState({
                reloadUser: true
            });
        },
        reloadSubscriptions() {
            this._widgetInstance.SaveState({
                reloadSubscriptions: true
            });
        }
    },
    components: {
        LoaderedButton,
        FlashMessage,
        InlineError,
        CountrySelect,
        AutoCompleteInput,
        Checkbox,
        Input
    },
    mixins: [errorsMixin, validator, autocomplete('Widget')]
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/widgets/dialog.js